import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  copy(event) {
    event.preventDefault()

    const targetLocale = event.target.dataset.locale

    if (!targetLocale) return

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({
        target_locale: targetLocale
      })
    })
      .then(response => {
        if (!response.ok) {
          console.error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        console.error('Error copying content:', error)
      })
  }
}
